import {
  getV1CompaniesCompanyIdOrdersTypeahead,
  Order_Read_Typeahead,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Order_Read_Typeahead,
  Order_Read_Typeahead,
  Record<string, unknown>
> & { companyId: string };

export default function AutocompleteOrdersTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteOrdersTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdOrdersTypeahead,
      }}
      parseFn={(item: Order_Read_Typeahead) => ({
        _entity: item,
        label: item.order_id,
        value: item.order_id,
      })}
    />
  );
}
